import checkbox from './checkbox.vue';
import textInput from './text.vue';
import passwordInput from './password.vue';
import singleSelect from './select.vue';
import simpleTextInput from './simpleText.vue';
import simpleSelectInput from './simpleSelect.vue';

const components = {
    checkbox,
    textInput,
    passwordInput,
    singleSelect,
    simpleTextInput,
    simpleSelectInput
};

components.install = Vue => {
    for (const componentName in components) {
        const component = components[componentName];

        if (component && componentName !== 'install') {
            Vue.component(component.name, component);
        }
    }
};

export default components;
